import { ApiErrorInstance } from '~/api';

export type ServerErrorType = {
  message: string;
  error: Error | ApiErrorInstance | null;
};

const hasFieldError = (errorObj: any): boolean => {
  if (!errorObj) return false;

  // string error
  if (typeof errorObj === 'string') return true;

  // array: must contain a real error
  if (Array.isArray(errorObj)) {
    return errorObj.some(hasFieldError);
  }

  // object: must contain at least one real error
  if (typeof errorObj === 'object') {
    return Object.values(errorObj).some(hasFieldError);
  }

  return false;
};

const getServerErrorInitialValue = () => ({
  message: '',
  error: null
});

export { hasFieldError, getServerErrorInitialValue };
